import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
  filterByEmail: (email: string) => AxiosInstance.get<any[]>(`${Config.profile.userData}`,
    { params: {
        "email.equals": email
    }}
  ),
  get: (id: string) =>
  AxiosInstance.get<any>(`${Config.profile.userData}/${id}`),
  getUsers: (ids: []) => {
    const strIds = ids.join('&id.in=')
    return AxiosInstance.get<any>(`${Config.profile.userData}/?id.in=${strIds}`);
  },
  patch: (id: string, values: any) =>
  AxiosInstance.patch<any>(`${Config.profile.userData}/${id}`, {id, ...values})
}